import React from "react";

function Place(){
    return (
        <div className="flex justify-center mt-10 mb-20 bg-opacity-5" >
            <div className="w-[500px] sm:w-4/5 md:w-3/5 lg:w-2/5 text-center m-2 rounded-md shadow-xl shadow-black" style={{backgroundColor: "rgba(34,38,41,0.1)"}}>
            <h1 className="font-extrabold text-5xl lg:text-4xl md:text-3xl sm:text-2xl italic mt-5">Location & Time</h1>
                <p className=" text-justify p-5 lg:text-lg text-gray-400">Join us on February 10th, 2023 at the Science Building <b>146</b> at 5pm for an exciting event filled with innovation and technology. Don't miss out on the opportunity to network and learn from industry leaders in the field. See you there!</p>
            </div>
        </div>
    )
}

export default Place;